<script>
  import BoardDocuments from '@/components/board-documents.vue'
  import boardMembersCard from '@/components/board-members-card.vue'
  import DirectorCard from '@/components/card-director-profile.vue'
  // import HeadshotCircle from '@/components/headshot-circle.vue'
  export default {
    name: 'board-of-trustees',
    components: {
      BoardDocuments,
      boardMembersCard,
      DirectorCard
      // HeadshotCircle,
    },
    data: () => ({}),
    computed: {},
    methods: {},
    created() {},
    mounted() {
      const hash = this?.$route?.hash || ''
      if (hash?.includes('#')) {
        const el = document.querySelector(hash)
        if (el) {
          this.$nextTick(() => el.scrollIntoView({ behavior: 'smooth', block: 'end' }))
        }
      }
    }
  }
</script>

<template>
  <v-container class="d-flex flex-column align-center mb-8 rounded-lg">
    <h1 class="text-h2 text-center primary--text font-weight-bold">BOARD OF TRUSTEES</h1>
    <board-members-card id="members" class="my-16"></board-members-card>
    <director-card class="my-16"></director-card>
    <board-documents id="documents" class="my-16" />

    <!-- TODO: Get these from server -->
    <!-- <v-card max-width="700" width="100%" class="mt-8">
      <v-card-title class="text-h6 primary secondary--text">Meeting Documents</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item-group color="primary">
            <v-list-item href="https://eipl.org/Boardminutes/index.htm" target="_blank">
              <v-list-item-content>
                <v-list-item-title class="primary--text"> Board minutes</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item href="https://eipl.org/Boardminutes/index.htm#agenda" target="_blank">
              <v-list-item-content>
                <v-list-item-title class="primary--text"> Agenda</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item href="https://eipl.org/pdffiles/operationalbudget-2023-2024.pdf" target="_blank">
              <v-list-item-content>
                <v-list-item-title class="primary--text"> Operating Budget 2023-2024</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item href="https://eipl.org/Boardminutes/EIPL_Financial%20Statements_6-30-2022.pdf" target="_blank">
              <v-list-item-content>
                <v-list-item-title class="primary--text"> Financial Statements</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item href="https://eilibrary-my.sharepoint.com/:f:/g/personal/gedwards_eipl_org/Eq0MzGRvIH1GqrDRASL7AsgBP0EOknW--MIIF_on0cMNzg?e=jLhFV1" target="_blank">
              <v-list-item-content>
                <v-list-item-title class="primary--text"> Supporting Documents</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card> -->
  </v-container>
</template>

<style scoped></style>
